import Vue from 'vue'

import 'normalize.css/normalize.css'
import '@/utils/vconsole'
import ElementUI from 'element-ui'
import '@/styles/element-ui-base.scss'
import 'element-ui/lib/theme-chalk/icon.css'
import registryConfirm from './messageBox'
import '@/styles/index.scss'

import App from './App'
import store from './store'
import router from './router'
import moment from 'moment'
import FastClick from 'fastclick'
var deviceIsWindowsPhone = navigator.userAgent.indexOf('Windows Phone') >= 0
var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone
// FastClick的ios点击穿透解决方案
FastClick.prototype.focus = function(targetElement) {
  let length
  var useSelectionRange = deviceIsIOS
  if (useSelectionRange) {
    try {
      length = targetElement.value.length
      targetElement.focus()
      targetElement.setSelectionRange(length, length)
    } catch (error) {
      useSelectionRange = false
    }
  }
  if (!useSelectionRange) {
    targetElement.focus()
  }
}
FastClick.attach(document.body)
Vue.prototype.$moment = moment
moment.locale('zh-CN')
import '@/icons'
import '@/permission'
Vue.use(ElementUI)
Vue.use(registryConfirm)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
